module.exports = __webpack_public_path__ + "img/commodore-george-dewey.366deadd.png";